import {SafeHtml } from '@angular/platform-browser';

export interface ChatBotMessageModel {
  text: string;
  sender: 'user' | 'bot';
  typing?: boolean;
}

export interface Message {
  text: SafeHtml;
  sender: 'user' | 'bot';
  typing?: boolean;
  ChartData?:any;
  chartDecision?: ChartDecision;
  isError?: boolean;
  retryQuestion?: string;
  retryCount?: number;
  isRetryDisabled?: boolean;
}

export interface MessageHistory {
  text: string;
  role: 'user' | 'bot';
}

export interface ChartDataset {
  label: string;
  data: number[];
}

export interface ChartConfig {
  type: 'bar' | 'line';
  xAxisLabel: string;
  labels: string[];
  datasets: ChartDataset[];
}

export interface ChartDecision {
  showChart: boolean;
  config: ChartConfig | null;
  reason?: string;
}

export interface FAQItem {
    Id: number;
    Category: string;
    Question: string;
    DisplayOrder: number;
}

export interface FAQModule {
  name: string;
  open: boolean;
  Questions: FAQItem[];
}

export interface AIAgentTncResponseModel {
    Success:            boolean;
    Message:            string;
    Status:             TncAgreementStatus;
    CurrentAgreedValue: boolean;
}

export enum TncAgreementStatus {
    Agreed           = 1,
    Disagreed        = 2,
    AlreadyAgreed    = 3,
    AlreadyDisagreed = 4,
    Failed     = 5,
}

export interface AIAgreedTncRequest {
    userId:    number;
    agreedTnc: boolean;
}

export interface AIProcessingMessageStage {
  messages: string[];
  duration: number;
}

export const AI_PROCESSING_MESSAGES: AIProcessingMessageStage[] = [
  {
    messages: [
      'SSM AI Agent is understanding your request. 🧠',
      'SSM AI Agent is interpreting your question. 🧠',
      'SSM AI Agent is understanding what you’re looking for. 🧠',
      'SSM AI Agent is figuring out what you need. 🧠'
    ],
    duration: 5000
  },
  {
    messages: [
      'SSM AI Agent is analyzing the relevant data. ⚙️',
      'SSM AI Agent is looking through the available data. ⚙️',
      'SSM AI Agent is gathering the information needed. ⚙️',
      'SSM AI Agent is processing the relevant data. ⚙️'
    ],
    duration: 6000
  },
  {
    messages: [
      'SSM AI Agent is working through the results. 📊',
      'SSM AI Agent is analyzing the results. 📊',
      'SSM AI Agent is connecting the results to your request. 📊',
      'SSM AI Agent is finding the key insights. 📊'
    ],
    duration: 8000
  },
  {
    messages: [
      'SSM AI Agent is completing the analysis. 📝',
      'SSM AI Agent is reviewing the findings. 🔍',
      'SSM AI Agent is validating the analysis. 🔍',
      'SSM AI Agent is refining the results. 📝'
    ],
    duration: 9000
  },
  {
    messages: [
      'SSM AI Agent is preparing your final response. ✨',
      'SSM AI Agent is putting the insights together. ✨',
      'SSM AI Agent is getting your answer ready. ✨',
      'SSM AI Agent is finalizing the results. ✨'
    ],
    duration: 0
  }
];